/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: PJXTdMLnvs2R

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeBenefitsSectionRoleDropdownItem.module.css"; // plasmic-import: PJXTdMLnvs2R/css

import OverlayIcon from "./icons/PlasmicIcon__Overlay"; // plasmic-import: DUBaIaV24j-h/icon

createPlasmicElementProxy;

export type PlasmicHomeBenefitsSectionRoleDropdownItem__VariantMembers = {
  pov: "director" | "officer" | "administrator";
  active: "active";
};
export type PlasmicHomeBenefitsSectionRoleDropdownItem__VariantsArgs = {
  pov?: SingleChoiceArg<"director" | "officer" | "administrator">;
  active?: SingleBooleanChoiceArg<"active">;
};
type VariantPropType =
  keyof PlasmicHomeBenefitsSectionRoleDropdownItem__VariantsArgs;
export const PlasmicHomeBenefitsSectionRoleDropdownItem__VariantProps =
  new Array<VariantPropType>("pov", "active");

export type PlasmicHomeBenefitsSectionRoleDropdownItem__ArgsType = {
  onClick?: () => void;
};
type ArgPropType = keyof PlasmicHomeBenefitsSectionRoleDropdownItem__ArgsType;
export const PlasmicHomeBenefitsSectionRoleDropdownItem__ArgProps =
  new Array<ArgPropType>("onClick");

export type PlasmicHomeBenefitsSectionRoleDropdownItem__OverridesType = {
  item?: Flex__<"div">;
  avatar?: Flex__<"div">;
  img?: Flex__<"div">;
  svg?: Flex__<"svg">;
  text?: Flex__<"div">;
  role?: Flex__<"div">;
  name?: Flex__<"div">;
};

export interface DefaultHomeBenefitsSectionRoleDropdownItemProps {
  onClick?: () => void;
  pov?: SingleChoiceArg<"director" | "officer" | "administrator">;
  active?: SingleBooleanChoiceArg<"active">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeBenefitsSectionRoleDropdownItem__RenderFunc(props: {
  variants: PlasmicHomeBenefitsSectionRoleDropdownItem__VariantsArgs;
  args: PlasmicHomeBenefitsSectionRoleDropdownItem__ArgsType;
  overrides: PlasmicHomeBenefitsSectionRoleDropdownItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "pov",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.pov
      },
      {
        path: "active",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.active
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"item"}
      data-plasmic-override={overrides.item}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      aria-label={(() => {
        try {
          return `Select ${$state.pov} role`;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.item,
        {
          [sty.itemactive]: hasVariant($state, "active", "active"),
          [sty.itempov_administrator]: hasVariant(
            $state,
            "pov",
            "administrator"
          ),
          [sty.itempov_officer]: hasVariant($state, "pov", "officer")
        }
      )}
      onClick={async event => {
        const $steps = {};

        $steps["runOnClick"] = true
          ? (() => {
              const actionArgs = { eventRef: $props["onClick"] };
              return (({ eventRef, args }) => {
                return eventRef?.(...(args ?? []));
              })?.apply(null, [actionArgs]);
            })()
          : undefined;
        if (
          $steps["runOnClick"] != null &&
          typeof $steps["runOnClick"] === "object" &&
          typeof $steps["runOnClick"].then === "function"
        ) {
          $steps["runOnClick"] = await $steps["runOnClick"];
        }
      }}
      title={(() => {
        try {
          return `Select ${$state.pov} role`;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
    >
      <div
        data-plasmic-name={"avatar"}
        data-plasmic-override={overrides.avatar}
        className={classNames(projectcss.all, sty.avatar)}
      >
        <div
          data-plasmic-name={"img"}
          data-plasmic-override={overrides.img}
          className={classNames(projectcss.all, sty.img, {
            [sty.imgpov_administrator]: hasVariant(
              $state,
              "pov",
              "administrator"
            ),
            [sty.imgpov_officer]: hasVariant($state, "pov", "officer")
          })}
        />

        <OverlayIcon
          data-plasmic-name={"svg"}
          data-plasmic-override={overrides.svg}
          className={classNames(projectcss.all, sty.svg, {
            [sty.svgactive]: hasVariant($state, "active", "active"),
            [sty.svgpov_administrator]: hasVariant(
              $state,
              "pov",
              "administrator"
            ),
            [sty.svgpov_officer]: hasVariant($state, "pov", "officer")
          })}
          role={"img"}
        />
      </div>
      <div
        data-plasmic-name={"text"}
        data-plasmic-override={overrides.text}
        className={classNames(projectcss.all, sty.text)}
      >
        <div
          data-plasmic-name={"role"}
          data-plasmic-override={overrides.role}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.role,
            {
              [sty.roleactive]: hasVariant($state, "active", "active"),
              [sty.rolepov_administrator]: hasVariant(
                $state,
                "pov",
                "administrator"
              ),
              [sty.rolepov_officer]: hasVariant($state, "pov", "officer")
            }
          )}
        >
          {hasVariant($state, "pov", "administrator")
            ? "Administrator"
            : hasVariant($state, "pov", "officer")
              ? "Institutional Officer"
              : "Program Director"}
        </div>
        <div
          data-plasmic-name={"name"}
          data-plasmic-override={overrides.name}
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.name,
            {
              [sty.nameactive]: hasVariant($state, "active", "active"),
              [sty.namepov_administrator]: hasVariant(
                $state,
                "pov",
                "administrator"
              ),
              [sty.namepov_officer]: hasVariant($state, "pov", "officer")
            }
          )}
        >
          {hasVariant($state, "pov", "administrator")
            ? "Anna Facilitator"
            : hasVariant($state, "pov", "officer")
              ? "Dan Strategist"
              : "Mark Achiever"}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  item: ["item", "avatar", "img", "svg", "text", "role", "name"],
  avatar: ["avatar", "img", "svg"],
  img: ["img"],
  svg: ["svg"],
  text: ["text", "role", "name"],
  role: ["role"],
  name: ["name"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  item: "div";
  avatar: "div";
  img: "div";
  svg: "svg";
  text: "div";
  role: "div";
  name: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeBenefitsSectionRoleDropdownItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeBenefitsSectionRoleDropdownItem__VariantsArgs;
    args?: PlasmicHomeBenefitsSectionRoleDropdownItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<
      PlasmicHomeBenefitsSectionRoleDropdownItem__VariantsArgs,
      ReservedPropsType
    > &
    // Specify args directly as props
    Omit<
      PlasmicHomeBenefitsSectionRoleDropdownItem__ArgsType,
      ReservedPropsType
    > &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames:
            PlasmicHomeBenefitsSectionRoleDropdownItem__ArgProps,
          internalVariantPropNames:
            PlasmicHomeBenefitsSectionRoleDropdownItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeBenefitsSectionRoleDropdownItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "item") {
    func.displayName = "PlasmicHomeBenefitsSectionRoleDropdownItem";
  } else {
    func.displayName = `PlasmicHomeBenefitsSectionRoleDropdownItem.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeBenefitsSectionRoleDropdownItem = Object.assign(
  // Top-level PlasmicHomeBenefitsSectionRoleDropdownItem renders the root element
  makeNodeComponent("item"),
  {
    // Helper components rendering sub-elements
    avatar: makeNodeComponent("avatar"),
    img: makeNodeComponent("img"),
    svg: makeNodeComponent("svg"),
    text: makeNodeComponent("text"),
    role: makeNodeComponent("role"),
    _name: makeNodeComponent("name"),

    // Metadata about props expected for PlasmicHomeBenefitsSectionRoleDropdownItem
    internalVariantProps:
      PlasmicHomeBenefitsSectionRoleDropdownItem__VariantProps,
    internalArgProps: PlasmicHomeBenefitsSectionRoleDropdownItem__ArgProps
  }
);

export default PlasmicHomeBenefitsSectionRoleDropdownItem;
/* prettier-ignore-end */
